import httpClient from './httpClient'

const END_POINT = '/api/prematriculas'

const postPrematricula = (prematricula) => httpClient.post(END_POINT, prematricula )

const checkSolicitantePrematricula = (idpersona, idcurso) => httpClient( `${END_POINT}?curso=${idcurso}&persona=${idpersona}` )

const checkAlumnoPrematricula = (idcurso,idalumno,ididioma) => httpClient.get( `${END_POINT}?curso=${idcurso}&alumnos.alumno=${idalumno}&alumnos.idioma=${ididioma}` )

export {

    postPrematricula,
    checkAlumnoPrematricula,
    checkSolicitantePrematricula

}